import { Form, Input, Select } from "antd";
import { PackageGroup } from "shared/constants/packageOptions";

interface GiftCardFormProps {
  form: any;
  packageGroups: PackageGroup[];
}

const GiftCardForm = ({ form, packageGroups }: GiftCardFormProps) => {
  return (
    <Form form={form} layout="vertical">
      <Form.Item
        name="package"
        label="Багц"
        rules={[{ required: true, message: "Багцаа сонгоно уу" }]}
      >
        <Select
          options={packageGroups}
          placeholder="Багц сонгоно уу"
          showSearch
          optionFilterProp="label"
        />
      </Form.Item>

      <Form.Item
        name="code"
        label="Код"
        rules={[{ required: true, message: "Код оруулна уу" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item name="instagram" label="Instagram">
        <Input />
      </Form.Item>

      <Form.Item name="phone" label="Авсан хүний утас">
        <Input inputMode="numeric" maxLength={12} />
      </Form.Item>

      <Form.Item name="comephone" label="Ирэх хүний утас">
        <Input inputMode="numeric" maxLength={12} />
      </Form.Item>
    </Form>
  );
};

export default GiftCardForm;
